import { BlastworksClientEvent, ClientController } from "client-controller";
import { FowlEnterPickBonusState } from "state-machine/states/bonus/pick/fowl-enter-pick-bonus-state";

export class SocialEnterPickBonusState extends FowlEnterPickBonusState {
    /**
     * Lock the top bar
     */
    public onEnter(): void {
        ClientController.getInstance().raiseEvent(BlastworksClientEvent.BONUS_START);
        super.onEnter();
    }
}
